import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { LayoutService } from './layout';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastModule],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    private layoutService = inject(LayoutService);

    ngOnInit() {
        this.layoutService.initializeLayout();
    }

}
